require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconGlobe.tsx
var IconGlobe_exports = {};
__export(IconGlobe_exports, {
  default: () => IconGlobe_default
});
module.exports = __toCommonJS(IconGlobe_exports);

// src/assets/monochrome/globe.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgGlobe = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M10.5671 19H9.47469C9.35311 18.9863 9.23189 18.9715 9.11067 18.9585C7.46182 18.7824 5.95816 18.2226 4.63528 17.223C2.73589 15.7897 1.56277 13.8994 1.13884 11.5545C1.07964 11.2274 1.04546 10.8957 1 10.5665V9.44197C1.0131 9.39146 1.0231 9.34019 1.02995 9.28846C1.08239 8.59948 1.21569 7.91905 1.4271 7.26116C2.85147 2.808 7.50657 0.165612 12.0341 1.23841C16.716 2.34783 19.6669 6.79817 18.8705 11.5492C18.251 15.2461 15.2761 18.2289 11.5711 18.8613C11.2366 18.918 10.9008 18.9542 10.5671 19ZM7.51221 12.4942C9.16777 12.6933 10.8412 12.6933 12.4968 12.4942C12.6975 10.8393 12.6975 9.16634 12.4968 7.51149C10.8414 7.31385 9.16833 7.31515 7.51327 7.51537C7.31267 9.16887 7.31173 10.8405 7.51045 12.4942H7.51221ZM13.9402 12.2689C14.3588 12.1537 14.7563 12.0576 15.1454 11.9347C15.8963 11.6992 16.6198 11.4066 17.253 10.92C17.4937 10.7352 17.6407 10.526 17.6012 10.2095C17.5861 10.0926 17.5861 9.97431 17.6012 9.85743C17.6498 9.49514 17.4853 9.25537 17.2034 9.04764C16.6441 8.63605 16.0214 8.35861 15.3688 8.1456C14.9061 7.9942 14.4332 7.87308 13.9381 7.73049C14.0886 9.23953 14.0887 10.7598 13.9384 12.2689H13.9402ZM12.2797 6.07217C12.1286 5.55707 11.9978 5.06592 11.8399 4.58391C11.6257 3.9315 11.341 3.31254 10.9191 2.76082C10.7345 2.51929 10.5227 2.37705 10.2073 2.41578C10.0903 2.43104 9.97189 2.43104 9.85492 2.41578C9.4916 2.36614 9.25303 2.53443 9.04442 2.81575C8.6293 3.37908 8.35056 4.00685 8.13701 4.66525C7.98865 5.12296 7.86813 5.58806 7.72717 6.07816C9.24009 5.92463 10.7645 5.92203 12.278 6.07042L12.2797 6.07217ZM12.2582 13.9398C10.7584 14.0885 9.24747 14.0885 7.74761 13.9398C7.82514 14.2416 7.88857 14.5204 7.96821 14.7954C8.19198 15.5791 8.47319 16.3379 8.9239 17.0269C9.16775 17.3998 9.44332 17.6371 9.94584 17.6089C10.6711 17.5684 10.7271 17.5811 11.1239 16.9671C11.7127 16.0457 12.0042 15.0123 12.2565 13.9381L12.2582 13.9398ZM6.0364 7.74563C5.63009 7.859 5.21602 7.96251 4.80936 8.08997C4.0866 8.31636 3.39345 8.60683 2.77993 9.0663C2.52269 9.25889 2.36059 9.47859 2.40534 9.81659C2.42097 9.93343 2.42097 10.0518 2.40534 10.1687C2.35601 10.5278 2.53185 10.7574 2.80531 10.9591C3.36913 11.3746 3.9971 11.6531 4.65642 11.8661C5.11453 12.0143 5.5804 12.1337 6.0371 12.2643C6.00926 11.4897 5.96098 10.7479 5.96134 10.006C5.96169 9.26417 6.00891 8.51212 6.0364 7.74563ZM17.1265 12.6692C17.0972 12.6759 17.0683 12.6843 17.0399 12.6942C16.0327 13.1843 14.9681 13.4934 13.8683 13.6944C13.7425 13.7177 13.7136 13.7856 13.6921 13.892C13.5459 14.669 13.3489 15.4327 13.0624 16.171C12.9429 16.4784 12.8097 16.7805 12.6681 17.1216C14.7958 16.2629 16.2632 14.7968 17.1265 12.6706V12.6692ZM7.3487 2.88828C6.32909 3.26992 5.40314 3.86537 4.63317 4.63454C3.8632 5.40371 3.26709 6.32876 2.88495 7.34742C3.0548 7.27031 3.18659 7.2087 3.3198 7.1499C4.21276 6.75522 5.14731 6.49819 6.1037 6.31441C6.19673 6.29645 6.27989 6.28765 6.3021 6.16301C6.50719 5.04268 6.82399 3.9572 7.3487 2.88968V2.88828ZM7.31805 17.1142C7.31805 17.072 7.32157 17.0593 7.31805 17.0509C6.82153 16.0407 6.51142 14.9711 6.30809 13.8687C6.28518 13.7441 6.21646 13.7187 6.11251 13.6927C5.39997 13.5068 4.68461 13.329 3.97983 13.117C3.61475 13.0075 3.26941 12.8329 2.88142 12.6741C3.73809 14.794 5.20475 16.259 7.31805 17.1156V17.1142ZM17.0927 7.32313C16.7301 5.70354 14.2172 3.19424 12.6779 2.92208C12.6874 2.94672 12.6934 2.96749 12.703 2.98686C13.1871 3.98326 13.4923 5.03634 13.6949 6.12041C13.7182 6.24399 13.7756 6.28483 13.8933 6.31582C14.6446 6.51334 15.3966 6.71015 16.1409 6.93302C16.4669 7.0316 16.7741 7.19075 17.0927 7.32313Z", fill: "#676F7E" }) });
var globe_default = SvgGlobe;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconGlobe.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconGlobe = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(globe_default, {}) });
};
IconGlobe.displayName = "IconGlobe";
var IconGlobe_default = IconGlobe;
